import { BIOME_HOW_IT_WORKS } from 'constants/textBunchesNames'
import withLocalization from 'containers/withLocalization'

import Component from './BiomeHowItWorks'

export default withLocalization(Component, BIOME_HOW_IT_WORKS)
